// Once per full page load, not once per mount: redux fills in reports after the
// initial render, so a useRef would fire again when the banner remounts with
// report context. SPA navigation back to the landing page in the same session
// does not re-fire the view event.
let hasSentAnalyticsEvent = false;

export const hasBannerViewBeenTracked = () => hasSentAnalyticsEvent;

export const markBannerViewTracked = () => {
  hasSentAnalyticsEvent = true;
};

export const resetBannerViewTracking = () => {
  hasSentAnalyticsEvent = false;
};
